import { defineStore } from 'pinia'
import api from '@/api'
import type { UpcomingDraw } from '@/types/lottery'

export interface UpcomingDrawsPagination {
  total_count: number
  total_pages: number
  current_page: number
  limit: number
}

export const useUpcomingDrawsStore = defineStore('upcomingDraws', {
  state: () => ({
    draws: [] as UpcomingDraw[],
    loading: false,
    error: null as string | null,
    pagination: {
      total_count: 0,
      total_pages: 1,
      current_page: 1,
      limit: 20,
    } as UpcomingDrawsPagination,
  }),
  actions: {
    async fetchDraws(page = 1, drawDate?: string) {
      this.loading = true
      this.error = null
      try {
        // Build request payload - only include drawDate if provided
        const payload: { page: number; limit: number; drawDate?: string } = {
          page,
          limit: this.pagination.limit,
        }
        if (drawDate) {
          payload.drawDate = drawDate
        }
        
        const { data } = await api.post('/upcoming-draws', payload)
        
        let drawsArr: UpcomingDraw[] = []
        let paginator = { ...this.pagination }
        if (data && data.result && data.result.result) {
          drawsArr = data.result.result
          if (data.result.paginator) {
            paginator = { ...paginator, ...data.result.paginator }
          }
        }
        if (page === 1) {
          this.draws = drawsArr
        } else {
          this.draws = [...this.draws, ...drawsArr]
        }
        this.pagination = paginator
      } catch (e: unknown) {
        console.error('Error fetching upcoming draws:', e)
        this.error = (e as { userMessage?: string; message?: string })?.userMessage || 
                     (e as { userMessage?: string; message?: string })?.message || 
                     'Failed to fetch upcoming draws'
      } finally {
        this.loading = false
      }
    },
    async fetchAllProducts(page = 1) {
      this.loading = true
      this.error = null
      try {
        const { data } = await api.post('/products', {
          page,
          limit: this.pagination.limit,
        })
        
        let drawsArr: UpcomingDraw[] = []
        let paginator = { ...this.pagination }
        if (data && data.result && data.result.result) {
          drawsArr = data.result.result
          if (data.result.paginator) {
            paginator = { ...paginator, ...data.result.paginator }
          }
        }
        if (page === 1) {
          this.draws = drawsArr
        } else {
          this.draws = [...this.draws, ...drawsArr]
        }
        this.pagination = paginator
      } catch (e: unknown) {
        console.error('Error fetching all products:', e)
        this.error = (e as { userMessage?: string; message?: string })?.userMessage || 
                     (e as { userMessage?: string; message?: string })?.message || 
                     'Failed to fetch products'
      } finally {
        this.loading = false
      }
    },
    setPage(page: number) {
      this.pagination.current_page = page
      this.fetchDraws(page)
    },
  },
}) 